/*
 * Dark Mode Toggle Button Molecule Component
 *
 */

import React from "react"
import { useDarkMode } from "../../../hooks/useDarkMode"
import Button from "../../atoms/button/button"

const DarkModeToggle = () => {
  const { darkModeToggle } = useDarkMode()

  return (
    <Button
      className="dark-mode-toggle"
      icon="dark-mode"
      iconModifier="--small"
      text="Dark Mode"
      onClick={() => darkModeToggle()}
    />
  )
}

export default DarkModeToggle
